<template>
  <div class="promo-skel" :class="`is-${variant}`" aria-hidden="true">
    <template v-if="variant === 'card'">
      <div v-for="n in count" :key="n" class="sk sk-card" />
    </template>

    <template v-else-if="variant === 'row'">
      <div v-for="n in count" :key="n" class="sk-row">
        <div class="sk sk-icon" />
        <div class="sk-lines">
          <div class="sk sk-line" />
          <div class="sk sk-line short" />
        </div>
        <div class="sk sk-amount" />
      </div>
    </template>

    <template v-else>
      <div class="sk sk-hero" />
      <div class="sk-grid">
        <div v-for="n in 4" :key="n" class="sk sk-tile" />
      </div>
      <div class="sk sk-table" />
    </template>
  </div>
</template>

<script setup lang="ts">
/** 奖励页骨架屏：形状与真实内容一致，避免「加载中…」文字占位造成布局跳动 */
withDefaults(defineProps<{ variant: 'card' | 'row' | 'vip'; count?: number }>(), { count: 4 })
</script>

<style scoped lang="scss">
.sk {
  position: relative;
  overflow: hidden;
  background: var(--surface2);

  &::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: linear-gradient(
      100deg,
      transparent 30%,
      rgba(255, 255, 255, 0.08) 50%,
      transparent 70%
    );
    animation: promo-shimmer 1.5s linear infinite;
  }
}

.is-card {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
}

.sk-card {
  height: 100px;
  border-radius: var(--r-lg);
}

.sk-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border-bottom: 1px solid var(--hairline);
}

.sk-icon {
  flex: 0 0 38px;
  height: 38px;
  border-radius: 11px;
}

.sk-lines {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.sk-line {
  height: 12px;
  border-radius: 6px;

  &.short {
    width: 55%;
    height: 10px;
  }
}

.sk-amount {
  flex: 0 0 56px;
  height: 14px;
  border-radius: 7px;
}

.sk-hero {
  height: 150px;
  border-radius: var(--r-xl);
}

.sk-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin: 14px 0 4px;
}

.sk-tile {
  height: 96px;
  border-radius: 14px;
}

.sk-table {
  height: 180px;
  margin-top: 10px;
  border-radius: var(--r-lg);
}
</style>
